module.exports = __webpack_public_path__ + "img/1.ba02d625.jpg";